import useIntersection from '@ui/hooks/useIntersection';
import React, { useRef } from 'react';

const DeepenYourBondExpertise = () => {
    const ref = useRef(null);
    const showAnimate = useIntersection(ref);
    const text = "Deepen your Bond expertise with Jiraaf’s one-stop analytical powerhouse, designed to unlock insights like never before!";
    const words = text.split(' ');

    return (
        <div className="relative z-10 pt-20 pb-32 xl:pb-60">
            <h2 className="h3-semibold xl:h1-semibold w-full px-6 xl:w-1/2 mx-auto flex flex-wrap" ref={ref}>
                {words.map((word, index) => (
                    <span
                        key={index}
                        className={`mr-1 opacity-20 ${showAnimate ? 'animate-fade-in-word' : ''}`}
                        style={{
                            animationDelay: `${index * 0.2}s`,
                        }}
                    >
                        {word}
                    </span>
                ))}
            </h2>
        </div>
    );
};

export default DeepenYourBondExpertise;